import styled from 'styled-components'
import { darkOrange, black, white, border2 } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export { Button } from '@components/Button'

export const PickerList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const Checkbox = styled.span<{ $checked: boolean }>`
    width: 22px;
    height: 22px;
    border-radius: ${radii.small};
    border: 2px solid ${({ $checked }) => ($checked ? darkOrange : border2)};
    background: ${({ $checked }) => ($checked ? darkOrange : white)};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${white};
    font-size: ${fontSizes.small};
    font-weight: 700;
    line-height: ${leading.none};
`


export const PickerName = styled.span`
    font-size: ${fontSizes.base};
    font-weight: 500;
    color: ${black};
    flex: 1;
`

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
`

